import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { WagmiProvider } from 'wagmi';

import { ThemeProvider } from '@/shared/theme';

import store from 'store';
import { AlertProvider } from 'ui/AlertProvider';
import { wagmiConfig } from 'web3/wagmi';

import { SonnerProvider } from './SonnerProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

export const AppProviders = ({ children }: PropsWithChildren) => (
  <WagmiProvider config={wagmiConfig}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ReduxProvider store={store}>
          <AlertProvider>
            <SonnerProvider />
            {children}
          </AlertProvider>
        </ReduxProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </WagmiProvider>
);
